import * as boUrls from 'mk2/apps/bo/urls';
import { DynamicRoute } from 'mk2/containers/Application/Application';

export const routes: DynamicRoute[] = [{
    app: 'bo',
    exact: true,
    path: boUrls.boOrdersReportTesting,
    getPage: () => {
        return import('mk2/apps/bo/containers/OrdersReportTesting/OrdersReportTestingPage' /* webpackChunkName: "bo.OrdersReportTesting" */);
    },
    modules: [ 'mk2/apps/bo/containers/OrdersReportTesting/OrdersReportTestingPage' ],
}, {
    app: 'bo',
    exact: true,
    path: boUrls.boOrdersReportAmbassador,
    getPage: () => {
        return import('mk2/apps/bo/containers/OrdersReportAmbassador/OrdersReportAmbassadorPage' /* webpackChunkName: "bo.OrdersReportAmbassador" */);
    },
    modules: [ 'mk2/apps/bo/containers/OrdersReportAmbassador/OrdersReportAmbassadorPage' ],
}, {
    app: 'bo',
    exact: true,
    path: boUrls.boOrdersReport,
    getPage: () => {
        return import('mk2/apps/bo/containers/OrdersReport/OrdersReportPage' /* webpackChunkName: "bo.OrdersReport" */);
    },
    modules: [ 'mk2/apps/bo/containers/OrdersReport/OrdersReportPage' ],
}, {
    app: 'bo',
    exact: true,
    path: boUrls.boPaymentOrders,
    getPage: () => {
        return import('mk2/apps/bo/containers/PaymentOrders/PaymentOrdersPage' /* webpackChunkName: "bo.PaymentOrders" */);
    },
    modules: [ 'mk2/apps/bo/containers/PaymentOrders/PaymentOrdersPage' ],
}, {
    app: 'bo',
    exact: true,
    path: boUrls.boOrders,
    getPage: () => {
        return import('mk2/apps/bo/containers/Orders/OrdersPage' /* webpackChunkName: "bo.Orders" */);
    },
    modules: [ 'mk2/apps/bo/containers/Orders/OrdersPage' ],
}, {
    app: 'bo',
    path: boUrls.boCommentsSnap,
    getPage: () => {
        return import('mk2/apps/bo/containers/CommentsSnap/CommentsSnapPage' /* webpackChunkName: "bo.CommentsSnap" */);
    },
    modules: [ 'mk2/apps/bo/containers/CommentsSnap/CommentsSnapPage' ],
}, {
    app: 'bo',
    exact: true,
    path: boUrls.boOrdersChart,
    getPage: () => {
        return import('mk2/apps/bo/containers/OrdersChart/OrdersChartPage' /* webpackChunkName: "bo.OrdersChart" */);
    },
    modules: [ 'mk2/apps/bo/containers/OrdersChart/OrdersChartPage' ],
}, {
    app: 'bo',
    exact: true,
    path: boUrls.boOrdersProducts,
    getPage: () => {
        return import('mk2/apps/bo/containers/OrdersProducts/OrdersProductsPage' /* webpackChunkName: "bo.OrdersProducts" */);
    },
    modules: [ 'mk2/apps/bo/containers/OrdersProducts/OrdersProductsPage' ],
}, {
    app: 'bo',
    exact: true,
    path: boUrls.boOrdersSigned,
    getPage: () => {
        return import('mk2/apps/bo/containers/OrdersSigned/OrdersSignedPage' /* webpackChunkName: "bo.OrdersSigned" */);
    },
    modules: [ 'mk2/apps/bo/containers/OrdersSigned/OrdersSignedPage' ],
}, {
    app: 'bo',
    exact: true,
    path: boUrls.boOrderCreate,
    getPage: () => {
        return import('mk2/apps/bo/containers/OrderCreate/OrderCreatePage' /* webpackChunkName: "bo.OrderCreate" */);
    },
    modules: [ 'mk2/apps/bo/containers/OrderCreate/OrderCreatePage' ],
}, {
    app: 'bo',
    exact: true,
    path: boUrls.boOrdersEdit,
    getPage: () => {
        return import('mk2/apps/bo/containers/OrderEdit/OrderEditPage' /* webpackChunkName: "bo.OrderEdit" */);
    },
    modules: [ 'mk2/apps/bo/containers/OrderEdit/OrderEditPage' ],
}, {
    app: 'bo',
    exact: true,
    path: boUrls.boOrdersHistory,
    getPage: () => {
        return import('mk2/apps/bo/containers/OrderHistory/OrderHistoryPage' /* webpackChunkName: "bo.OrderHistory" */);
    },
    modules: [ 'mk2/apps/bo/containers/OrderHistory/OrderHistoryPage' ],
}, {
    app: 'bo',
    exact: true,
    path: boUrls.boOrdersDetail,
    getPage: () => {
        return import('mk2/apps/bo/containers/OrderDetail/OrderDetailPage' /* webpackChunkName: "bo.OrderDetail" */);
    },
    modules: [ 'mk2/apps/bo/containers/OrderDetail/OrderDetailPage' ],
}];
